import '../../styles/Embed.css';

import { EmbedComponent } from '../../models/LessonComponent';
import { EmbedEdit } from './EmbedEdit';
import { EmbedView } from './EmbedView';
import { LessonContextConsumer } from '../../models/LessonContext';
import React from 'react';

export interface EmbedComponentProps {
  component: EmbedComponent;
}

export default function EmbedComponentView(props: EmbedComponentProps) {
  return (
    <LessonContextConsumer>
      {({ mode }) => (
        <>
          {mode === 'edit' ? (
            <EmbedEdit {...props} />
          ) : (
            <EmbedView embedCode={props.component.content.embedCode} />
          )}
        </>
      )}
    </LessonContextConsumer>
  );
}
